import { Component, EventEmitter, Output } from '@angular/core';
import { Common } from '../../shared/common';
import { Voter } from 'src/app/models/Voter';

@Component({
  selector: 'voters-add-popup',
  templateUrl: './voters-add-popup.component.html',
  styleUrls: ['./voters-add-popup.component.less', '../../shared/common.less']
})
export class VotersAddPopupComponent {
  @Output() isClosed = new EventEmitter<boolean>();
  @Output() voterAdded = new EventEmitter<Voter>();

  isActive = false
  firstName = '';
  lastName = '';
  college = '';
  email = '';
  phone = '';
  challenge = '';

  get isFormValid(): boolean {
    return this.firstName.trim().length > 0
      && this.lastName.trim().length > 0
      && this.email.trim().length > 0 
      && this.college.trim().length > 0;
  }

  onDismiss(confirm: boolean) {
    if (confirm) {
      const voter = new Voter(
        this.firstName,
        this.lastName,
        this.email,
        '1',
        this.phone,
        this.challenge,
        '',
        this.college
      );
      this.voterAdded.emit(voter);
    }
    this.isClosed.emit(confirm);
  }

  constructor(public common: Common) { }

}
